import {CreativePreviewDrawerSearchParamKey} from './creatives.types';

const DEFAULT_CREATIVE_COUNTRY = 'US';
const MAX_CREATIVES_TO_CONNECT_TO_CAMPAIGN = 20;
const MAX_CREATIVE_NAME_LENGTH = 100;
const TEMPLATE_DEFAULT_CREATIVE_LABEL = 'Template Default Creative';

const creativePreviewFiltersConfig = {
  [CreativePreviewDrawerSearchParamKey.FeedId]: {
    refetchDataOnChange: false,
    defaultValue: '',
  },
  [CreativePreviewDrawerSearchParamKey.ProductSet]: {
    refetchDataOnChange: false,
    defaultValue: '',
  },
  [CreativePreviewDrawerSearchParamKey.TopItemList]: {
    refetchDataOnChange: false,
    defaultValue: '',
  },
  [CreativePreviewDrawerSearchParamKey.CategoryTopItem]: {
    refetchDataOnChange: false,
    defaultValue: '',
  },
  [CreativePreviewDrawerSearchParamKey.CategoryTopItemName]: {
    refetchDataOnChange: false,
    defaultValue: '',
  },
};

export {
  DEFAULT_CREATIVE_COUNTRY,
  MAX_CREATIVES_TO_CONNECT_TO_CAMPAIGN,
  MAX_CREATIVE_NAME_LENGTH,
  creativePreviewFiltersConfig,
  TEMPLATE_DEFAULT_CREATIVE_LABEL,
};
